import { c as _c } from "react/compiler-runtime";
import { getTranslations } from 'next-intl/server';
import { Link } from '@/i18n/navigation';
import { MapPin, Calendar, ArrowRight, CalendarDaysIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { AnimatedGrid, AnimatedSection, LazyImage, NoImagePlaceholder } from '@/components/partials';
import { getAppLocale, buildTranslatedRoute } from '@/lib/utils.server';
import { formatLongDateTime, getEventStatus, stripHtmlTags, getResizedPictureUrl, getLocalizedValue } from '@/lib/utils';
import { fetchEvents } from '@/lib/api';
import { SortEnum } from '@/enums';
type PropsType = {
  itemSize?: number;
  title?: string;
  excludeIds?: string[];
};
const EventsSection = async t0 => {
  const $ = _c(32);
  const {
    itemSize: t1,
    title,
    excludeIds: t2
  } = t0;
  const itemSize = t1 === undefined ? 3 : t1;
  const excludeIds = t2 === undefined ? undefined : t2;
  let T0;
  let T1;
  let t10;
  let t11;
  let t12;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== excludeIds || $[1] !== itemSize || $[2] !== title) {
    t12 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const t = await getTranslations();
      const {
        backendLocale
      } = await getAppLocale();
      const baseRoute = await buildTranslatedRoute(backendLocale, "events");
      const {
        items: t13
      } = await fetchEvents({
        excludeIds,
        page: 1,
        size: itemSize,
        sortBy: "createdAt",
        sort: SortEnum.DESC
      });
      const items = t13 === undefined ? [] : t13;
      if (items.length === 0) {
        t12 = null;
        break bb0;
      }
      const itemsWithLinks = await Promise.all(items.map(async item => ({
        ...item,
        detailHref: await buildTranslatedRoute(backendLocale, "events", getLocalizedValue(item, "slug", backendLocale))
      })));
      t9 = "flex flex-col items-center justify-center space-y-8 px-4 py-20";
      t10 = <AnimatedSection animation="fade-up" className="w-full"><h2 className="text-center text-3xl font-bold uppercase">{title ?? t("events")}</h2></AnimatedSection>;
      t11 = <AnimatedGrid className="flex w-full max-w-7xl flex-wrap justify-center gap-6">{itemsWithLinks.map(item_0 => {
          const title_0 = getLocalizedValue(item_0, "title", backendLocale);
          const content = getLocalizedValue(item_0, "content", backendLocale);
          const status = getEventStatus(item_0.beginDate, item_0.endDate);
          if (title_0 === "-") {
            return null;
          }
          return <Link key={item_0.id} href={item_0.detailHref} className="group bg-card flex w-full flex-col overflow-hidden rounded-lg border transition-all hover:shadow-lg md:w-[calc(50%-0.75rem)] xl:w-[calc(33.333%-1rem)]"><div className="bg-muted relative flex h-48 w-full items-center justify-center overflow-hidden">{item_0.mainPicture ? <><LazyImage src={getResizedPictureUrl(item_0.mainPicture.path, 800, 600)} alt={title_0} fill={true} sizes="(max-width: 768px) 100vw, (max-width: 1280px) 50vw, 33vw" className="object-cover transition-transform duration-300 group-hover:scale-110" /><div className="absolute top-3 left-3 z-10 select-none"><Badge className={`px-3 py-1 text-xs font-semibold shadow-lg ${status.className}`}>{t(status.key)}</Badge></div></> : <NoImagePlaceholder icon={CalendarDaysIcon} />}</div><div className="flex flex-1 flex-col space-y-3 p-5"><h3 className="group-hover:text-primary text-xl font-semibold transition-colors">{title_0}</h3>{content && stripHtmlTags(content).trim() && <p className="text-muted-foreground line-clamp-2 text-sm">{stripHtmlTags(content)}</p>}<div className="flex-1" /><div className="space-y-2 border-t pt-3"><div className="flex items-start gap-2 text-sm"><Calendar className="text-muted-foreground mt-0.5 h-4 w-4 shrink-0" /><div className="flex flex-col gap-1"><div className="flex items-center gap-1"><span className="text-muted-foreground">{t("start")}:</span><time className="font-medium">{formatLongDateTime(item_0.beginDate, backendLocale)}</time></div><div className="flex items-center gap-1"><span className="text-muted-foreground">{t("end")}:</span><time className="font-medium">{formatLongDateTime(item_0.endDate, backendLocale)}</time></div></div></div>{item_0.address && <div className="flex items-start gap-2 text-sm"><MapPin className="text-muted-foreground mt-0.5 h-4 w-4 shrink-0" /><span className="text-muted-foreground">{item_0.address}</span></div>}</div></div></Link>;
        })}</AnimatedGrid>;
      T1 = Button;
      t5 = true;
      t6 = "brand";
      t7 = "xl";
      t8 = "gap-2 uppercase";
      T0 = Link;
      t3 = baseRoute;
      t4 = t("view_all");
    }
    $[0] = excludeIds;
    $[1] = itemSize;
    $[2] = title;
    $[3] = T0;
    $[4] = T1;
    $[5] = t10;
    $[6] = t11;
    $[7] = t12;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    T0 = $[3];
    T1 = $[4];
    t10 = $[5];
    t11 = $[6];
    t12 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
    t8 = $[13];
    t9 = $[14];
  }
  if (t12 !== Symbol.for("react.early_return_sentinel")) {
    return t12;
  }
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <ArrowRight className="h-5 w-5" />;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== T0 || $[17] !== t3 || $[18] !== t4) {
    t14 = <T0 href={t3}>{t4}{t13}</T0>;
    $[16] = T0;
    $[17] = t3;
    $[18] = t4;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== T1 || $[21] !== t14 || $[22] !== t5 || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
    t15 = <T1 asChild={t5} variant={t6} size={t7} className={t8}>{t14}</T1>;
    $[20] = T1;
    $[21] = t14;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t15 || $[30] !== t9) {
    t16 = <section className={t9}>{t10}{t11}{t15}</section>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t15;
    $[30] = t9;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  return t16;
};
export default EventsSection;